export const generateID = () => Math.floor(Math.random() * 1000000).toString()
